// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { OperatorDef, OperatorRef, OperatorUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OperatorActions {
  export class GetAllOperators {
    static readonly type = '[Operator] GetAllOperator';
    readonly type = GetAllOperators.type;
  }

  export class InitOperatorCount {
    static readonly type = '[Operator] InitOperatorsCount';
    readonly type = InitOperatorCount.type;
  }

  export class InitOperator {
    static readonly type = '[Operator] InitOperators';
    readonly type = InitOperator.type;
  }
  export class CountOperators {
    static readonly type = '[Operator] CountOperators';
    readonly type = CountOperators.type;
  }

  export class CloseOperatorsConnection {
    static readonly type = '[Operator] CloseOperatorsConnection';
    readonly type = CloseOperatorsConnection.type;
  }

  export class GetOperatorById {
    static readonly type = '[Operator] GetOperatorById';
    readonly type = GetOperatorById.type;
  }

  export class UpdateOperator {
    static readonly type = '[Operator] UpdateOperator';
    constructor(
      public operatorData: Partial<OperatorUpdateData>,
      public ref: OperatorRef,
    ) {}
  }

  export class DeleteOperators {
    static readonly type = '[Operator] DeleteOperators';
    constructor(public refs: OperatorRef[]) {}
  }

  export class PaginateQueryOperator {
    static readonly type = '[Operator] PaginateQueryOperator';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public operatorId?: string,
    ) {}
  }
  export class OperatorError {
    static readonly type = '[Operator] OperatorError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Operator] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Operator] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public operatorId?: string,
    ) {}
  }

  export class UpdateOperatorResult {
    static readonly type = '[Operator] UpdateOperatorResult';
    constructor(public data: Array<TypesaurusCoreDoc<OperatorDef> | null | undefined>) {}
  }
}
